import { render, staticRenderFns } from "./CourseViewer.vue?vue&type=template&id=b87bdb88&"
import script from "./CourseViewer.vue?vue&type=script&lang=js&"
export * from "./CourseViewer.vue?vue&type=script&lang=js&"
import style0 from "./CourseViewer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CourseViewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports